<template>
  <div>
    <v-dialog
      v-model="popupdialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Popup-Modal
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Popup notifier inside a modal
        </v-card-title>

        <v-card-text class=" text-center mt-3">
         <v-btn color="orange" @click="simpleString2()" class="ma-2" dark>Simple-String</v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="popupdialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notificationMixin from "@/_mixins/notification-mixin";
  export default {
   mixins: [notificationMixin],
    data () {
      return {
        popupdialog: false,
      }
    },
    methods:{
     simpleString2(){
      this.addNotification("Its a simple string");
    },
    }
  }
</script>